const Footer = () => {
  return (
    <div className="text-center p-4">
      © 2023 Copyright:
      <a
        className="text-reset fw-bold px-2"
        href="https://princetonlogic.com/"
        style={{ textDecoration: "none" }}
      >
        princetonlogic.com
      </a>
    </div>
  );
};
export default Footer;
